// assets/pack-2x50.js
(() => {
  console.log("[2x50] script cargado - versión cupones por subtotal + cart page");

  const PACK_SIZE = 2; // 2 productos

  // Mapeo: subtotal (en céntimos) -> código de descuento
  // Cupones creados en Shopify con estos mismos códigos.
  const DISCOUNTS_BY_SUBTOTAL = {
    5290: "2X5029",   // 52,90 € -> desc. 2,90 €
    5490: "2X5049",   // 54,90 € -> desc. 4,90 €
    5590: "2X5059",   // 55,90 € -> desc. 5,90 €
    5790: "2X5079",   // 57,90 € -> desc. 7,90 €
    5990: "2X5099",   // 59,90 € -> desc. 9,90 €
    6290: "2X50129",  // 62,90 € -> desc. 12,90 €
    6490: "2X50149",  // 64,90 € -> desc. 14,90 €
    6590: "2X50159",  // 65,90 € -> desc. 15,90 €
    6790: "2X50179",  // 67,90 € -> desc. 17,90 €
    6990: "2X50199"   // 69,90 € -> desc. 19,90 €
  };

  let currentDiscountCode = null;

  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`HTTP ${res.status} en ${url}`);
    return res.json();
  }

  async function fetchCart() {
    return fetchJSON("/cart.js");
  }

  /**
   * Devuelve true si el ítem es "válido" para el pack:
   * - precio > 0
   * - título NO contiene "pack"
   */
  function isEligibleItem(item) {
    const price = item.price || 0; // en céntimos
    if (price <= 0) return false;

    const title =
      (item.product_title || item.title || "").toString().toLowerCase();

    if (title.includes("pack")) return false;

    return true;
  }

  /**
   * Evalúa si el carrito cumple las reglas del pack 2x50
   * y qué cupón debe usar según el subtotal en céntimos.
   */
  async function evaluateCartRules(cart) {
    const items = cart.items || [];

    let totalQty = 0;
    let eligibleQty = 0;
    let eligibleSubtotalCents = 0;

    for (const item of items) {
      const qty = item.quantity || 0;
      totalQty += qty;

      if (isEligibleItem(item)) {
        eligibleQty += qty;

        // 🔴 IMPORTANTE: usamos el precio ORIGINAL de línea para ignorar descuentos previos
        const baseLinePriceCents =
          typeof item.original_line_price === "number"
            ? item.original_line_price
            : typeof item.line_price === "number"
              ? item.line_price
              : (item.price || 0) * qty;

        eligibleSubtotalCents += baseLinePriceCents;
      }
    }

    // Reglas actuales: exactamente 2 unidades en el carrito
    // y las 2 son productos elegibles.
    const exactlyTwoItems = totalQty === PACK_SIZE;
    const exactlyTwoEligible = eligibleQty === PACK_SIZE;

    let discountCode = null;

    if (exactlyTwoItems && exactlyTwoEligible) {
      discountCode = DISCOUNTS_BY_SUBTOTAL[eligibleSubtotalCents] || null;
    }

    const eligible = Boolean(discountCode);

    console.log("[2x50] evaluación carrito", {
      totalQty,
      eligibleQty,
      eligibleSubtotalCents,
      discountCode,
      eligible
    });

    return { eligible, discountCode };
  }

  // Helpers para botones de checkout (drawer + página de carrito)
  function getCheckoutButtons() {
    // Todos los botones de checkout de la página (drawer, cart page, etc.)
    return Array.from(document.querySelectorAll("button[name='checkout']"));
  }

  function ensurePackButtons() {
    const checkoutButtons = getCheckoutButtons();
    const packButtons = [];

    checkoutButtons.forEach((checkoutBtn) => {
      if (!checkoutBtn) return;

      // Intentamos reutilizar si ya existe uno en el mismo contenedor
      let container = checkoutBtn.parentElement || checkoutBtn.closest("div") || checkoutBtn;
      let btn = container.querySelector("[data-pack-2x50-button]");

      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = checkoutBtn.className;
        btn.textContent = "Comprar los 2 por 50€";
        btn.setAttribute("data-pack-2x50-button", "true");

        // Insertamos nuestro botón justo antes del nativo
        checkoutBtn.parentNode.insertBefore(btn, checkoutBtn);

        btn.addEventListener("click", () => {
          if (currentDiscountCode) {
            const url =
              "/checkout?discount=" +
              encodeURIComponent(currentDiscountCode);
            window.location.href = url;
          } else {
            // Por seguridad, si algo falla, ir al checkout normal
            window.location.href = "/checkout";
          }
        });
      }

      packButtons.push(btn);
    });

    return { checkoutButtons, packButtons };
  }

  function updateButtons(eligible, discountCode) {
    const { checkoutButtons, packButtons } = ensurePackButtons();

    currentDiscountCode = discountCode || null;

    checkoutButtons.forEach((checkoutBtn, index) => {
      const packBtn = packButtons[index];
      if (!checkoutBtn || !packBtn) return;

      if (eligible) {
        packBtn.style.display = "";
        checkoutBtn.style.display = "none";
      } else {
        packBtn.style.display = "none";
        checkoutBtn.style.display = "";
      }
    });
  }

  async function refresh() {
    try {
      const cart = await fetchCart();
      const { eligible, discountCode } = await evaluateCartRules(cart);
      updateButtons(eligible, discountCode);
    } catch (err) {
      console.error("[2x50] Error refrescando 2x50", err);
    }
  }

  function debounce(fn, delay) {
    let id;
    return (...args) => {
      clearTimeout(id);
      id = setTimeout(() => fn(...args), delay);
    };
  }

  const debouncedRefresh = debounce(refresh, 500);

  document.addEventListener("DOMContentLoaded", () => {
    refresh();

    // Observar cambios en el drawer Minimog
    const drawerInner = document.querySelector(".m-cart-drawer__inner");
    if (drawerInner && "MutationObserver" in window) {
      const observer = new MutationObserver(() => debouncedRefresh());
      observer.observe(drawerInner, { childList: true, subtree: true });
    }

    // Clicks dentro del drawer = refresco
    document.addEventListener("click", (event) => {
      const target = event.target.closest("button, a");
      if (target && target.closest(".m-cart-drawer")) {
        debouncedRefresh();
      }
    });

    // Cambios de cantidad dentro del drawer
    document.addEventListener("change", (event) => {
      if (event.target.closest(".m-cart-drawer")) {
        debouncedRefresh();
      }
    });

    // Extra: refrescar también en la página de carrito cuando se cambian cantidades
    document.addEventListener("change", (event) => {
      if (event.target.closest("form[action='/cart']")) {
        debouncedRefresh();
      }
    });
  });

  // Eventos del tema
  document.addEventListener("cart:refresh", debouncedRefresh);
  document.addEventListener("cart:change", debouncedRefresh);
  document.addEventListener("ajaxCart:updated", debouncedRefresh);
})();
